import { api } from './index';

const BASE_PATH = '/api/internal/offices';

export type Office = {
  id: number;
  name: string;
  address: string;
  displayName: string;
  communeId: number;
  communeName?: string;
  humanCreatedAt?: string;
  humanDiscardedAt?: string;
};

export type OfficeForm = {
  name: string;
  address: string;
  communeId: number;
};

export const officesApi = {
  index(scope: 'active' | 'discarded' = 'active'): Promise<Array<Office>> {
    return api({
      method: 'get',
      url: `${BASE_PATH}?scope=${scope}`,
    }).then(response => response.data.offices);
  },

  create(office: OfficeForm): Promise<Office> {
    return api({
      method: 'post',
      url: BASE_PATH,
      data: { office },
    }).then(response => response.data.office);
  },

  update(office: OfficeForm & { id: number }): Promise<Office> {
    return api({
      method: 'put',
      url: `${BASE_PATH}/${office.id}`,
      data: { office },
    }).then(response => response.data.office);
  },

  destroy(id: number): Promise<void> {
    return api({
      method: 'delete',
      url: `${BASE_PATH}/${id}`,
    }).then(() => {});
  },
};
